//service
import { useApiFetcherSWR } from "hooks/SwrCustom";

export const API_ENDPOINT = {
  GET_SUB_REQUESTS: {
    url: "get-sub-requests",
    method: "get",
  },
};

export const useSubRequests = (adminId) =>
  useApiFetcherSWR(
    adminId
      ? {
          ...API_ENDPOINT.GET_SUB_REQUESTS,
          url: `${API_ENDPOINT.GET_SUB_REQUESTS.url}?iAdminId=${adminId}`,
        }
      : null
  );